// Remembers, for this page, the moment a player locked in on a question, so the answer view can show where on the
// clue meter they committed even after the screen changes. Keyed by question id and start time.
import type { LiveQuestion } from './types';

export interface LockInfo { at: number; shown: number; dealt: number }
const memo = new Map<string, LockInfo>();
const key = (q: Pick<LiveQuestion, 'id' | 'startsAt'>) => `${q.id}@${q.startsAt}`;

export function rememberLock(q: Pick<LiveQuestion, 'id' | 'startsAt'>, info: LockInfo): void {
  memo.set(key(q), info);
  while (memo.size > 40) { const first = memo.keys().next().value; if (first === undefined) break; memo.delete(first); }
}
export function recallLock(q: Pick<LiveQuestion, 'id' | 'startsAt'>): LockInfo | undefined {
  return memo.get(key(q));
}
export function forgetLocks(): void { memo.clear(); }
